/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreatePaymentResponseDataAdyenData,
    CreatePaymentResponseDataAdyenDataFromJSON,
    CreatePaymentResponseDataAdyenDataFromJSONTyped,
    CreatePaymentResponseDataAdyenDataToJSON,
} from './CreatePaymentResponseDataAdyenData';
import {
    CreatePaymentResponseDataTestData,
    CreatePaymentResponseDataTestDataFromJSON,
    CreatePaymentResponseDataTestDataFromJSONTyped,
    CreatePaymentResponseDataTestDataToJSON,
} from './CreatePaymentResponseDataTestData';

/**
 * 
 * @export
 * @interface CreatePaymentResponseData
 */
export interface CreatePaymentResponseData {
    /**
     * 
     * @type {CreatePaymentResponseDataTestData}
     * @memberof CreatePaymentResponseData
     */
    testData?: CreatePaymentResponseDataTestData;
    /**
     * 
     * @type {CreatePaymentResponseDataAdyenData}
     * @memberof CreatePaymentResponseData
     */
    adyenData: CreatePaymentResponseDataAdyenData;
}

export function CreatePaymentResponseDataFromJSON(json: any): CreatePaymentResponseData {
    return CreatePaymentResponseDataFromJSONTyped(json, false);
}

export function CreatePaymentResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'testData': !exists(json, 'testData') ? undefined : CreatePaymentResponseDataTestDataFromJSON(json['testData']),
        'adyenData': CreatePaymentResponseDataAdyenDataFromJSON(json['adyenData']),
    };
}

export function CreatePaymentResponseDataToJSON(value?: CreatePaymentResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'testData': CreatePaymentResponseDataTestDataToJSON(value.testData),
        'adyenData': CreatePaymentResponseDataAdyenDataToJSON(value.adyenData),
    };
}

